export default __webpack_public_path__ + "static/media/bg-pattern.164ab0ec.png";